import { IPC as IPCBase, COMMAND as COMMANDBASE } from '../../common/ipc';
import Logger from '../../common/logger';

export const COMMAND = COMMANDBASE;

class IPC extends IPCBase {
    remoteWindow() {
        return window.top;
    }

    source() {
        return 'oplwidget-child';
    }

    target() {
        return 'oplwidget-parent';
    }

    postMessage(json) {
        Logger.log('[IPC] child send: ' + JSON.stringify(json));
        super.postMessage(json);
    }

    sendReady() {
        this.sendEvent(COMMAND.READY);
    }

    sendFinish() {
        this.sendEvent(COMMAND.FINISH);
    }
}

export default new IPC(); // singleton
